module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-building-w-fa3eafe21632b9eef11b5c58299520ab.svg";